export default {
  miao: '[+3]',
  wang: '[+2]',
  de: '[+1]',
  li: '[0]',
  ping: '[-1]',
  bu: '[-2]',
  xian: '[-3]',
} as const;
